import { ChatListItem, ChatToggleData } from '@choco-admin/types';
import React from 'react';

import { ChatsTable } from './ChatsTable';
import { Pagination } from './Pagination';

interface ChatListContentProps {
  chats: ChatListItem[];
  isLoading: boolean;
  currentPage: number;
  totalPages: number;
  onNextPageClick: () => void;
  onPreviousPageClick: () => void;
  onChatToggle: (data: ChatToggleData) => Promise<void>;
}

export const ChatListContent: React.FC<ChatListContentProps> = ({
  chats,
  isLoading,
  currentPage,
  totalPages,
  onNextPageClick,
  onPreviousPageClick,
  onChatToggle,
}) => {
  return (
    <div className="space-y-6">
      <ChatsTable
        chats={chats}
        isLoading={isLoading}
        onChatToggle={onChatToggle}
      />

      {!isLoading && chats.length > 0 && (
        <Pagination
          currentPage={currentPage}
          onNextPageClick={onNextPageClick}
          onPreviousPageClick={onPreviousPageClick}
          totalPages={totalPages}
        />
      )}
    </div>
  );
};
